import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';

const Contact: React.FC = () => {
    return (
        <Box sx={{
            minHeight: 'calc(100vh - 64px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
        }}>
            <Container maxWidth="sm">
                <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
                    <Typography variant="h4" component="h1" gutterBottom align="center">
                        Contactez-nous
                    </Typography>

                    <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, textAlign: 'center' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <PersonIcon color="primary" />
                            <Typography variant="h6">
                                M. Rodolphe ZOLIN
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <LocationOnIcon color="primary" />
                            <Typography variant="h6">
                                LAGUNE PLONGEE
                            </Typography>
                            <Typography variant="body1">
                                Résidence le YACHTMAN<br />
                                Quai Arthur RIMBAUD<br />
                                66750 SAINT-CYPRIEN
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <PhoneIcon color="primary" />
                            <Typography variant="h6">
                                Téléphone: 06 13 78 86 11
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <EmailIcon color="primary" />
                            <Typography variant="h6">
                                Email: infolaguneplongee@gmail.com
                            </Typography>
                        </Box>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default Contact;